<div class="loading" [class.is-done]="isDone">
  <div class="loading-backdrop"></div>

  <img class="plane-loader" src="/assets/icon.png" alt="Loading" />
</div>
